import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const sentenceCase = (str: string): string => {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

export const lowerCase = (str: string): string => {
  return str.charAt(0).toLowerCase() + str.slice(1).toLowerCase();
};

export const isNotEmpty = (value: string | undefined) => value!.trim().length > 0;

/**
 * Gets a value from a nested object using a dot-notation path
 * @param obj The object to retrieve the value from
 * @param path The path to the value, using dot notation (e.g., "user.account")
 * @param defaultValue Optional default value if the path doesn't exist
 * @returns The value at the path, or the default value if not found
 */
export function getNestedValue<T = unknown>(obj: Record<string, unknown>, path: string, defaultValue?: T): T {
  const keys = path.split(".");
  let result: unknown = obj;

  for (const key of keys) {
    if (result === undefined || result === null || typeof result !== "object") {
      return defaultValue as T;
    }
    result = (result as Record<string, unknown>)[key];
  }

  return (result === undefined ? defaultValue : result) as T;
}
